import type { CoachFacts } from './facts.js';

/** Deterministic, kid-friendly one-liners. First matching rule wins. */
export function buildExplanation(f: CoachFacts): string {
  if (f.isMate) return 'Checkmate! This move wins the game.';
  if (f.isCheck) return 'This move gives check — the other player must answer it.';
  if (f.isCapture) {
    if (f.defended) return `This move captures a ${f.capturedName}.`;
    return `This move wins a ${f.capturedName}!`;
  }
  if (f.develops) return `This move develops your ${f.movingName}.`;
  if (f.controlGain > 0) return 'This move takes control of the board.';
  return `A calm move. Your ${f.movingName} stays safe.`;
}

/** Short imperative sentence for text-to-speech narration. First matching rule wins. */
export function buildSpeakable(f: CoachFacts): string {
  if (f.isMate) return 'Checkmate. You win the game.';
  if (f.isCheck) return 'This move gives check.';
  if (f.isCapture) {
    return f.defended ? `You capture a ${f.capturedName}.` : `You win a ${f.capturedName}!`;
  }
  if (f.develops) return `You develop your ${f.movingName}.`;
  if (f.controlGain > 0) return 'You take control of the board.';
  return `Your ${f.movingName} stays safe.`;
}
